module.exports = __webpack_public_path__ + "img/Persona1.952e79e5.jpg";